module.exports = __webpack_public_path__ + "img/基本信息背景.d620bfdd.png";